import { Pipe, PipeTransform } from '@angular/core';
import { Question } from '../../models/question.model';

@Pipe({ name: 'uniqueQuestions' })
export class UniqueQuestionsPipe implements PipeTransform {
  transform(questions: Question[], duplicateIds: string[]): Question[] {
    if (!duplicateIds || !questions) {
      return questions;
    }

    return questions.filter(question => {
      return duplicateIds.indexOf(question.id) === -1;
    });
  }
}
